import { UpgradeToPremiumModal } from "./upgrade-to-premium-modal";
import { useApp } from "@/app/providers/app-provider";
import { AccountRequiredModal } from "./account-required-modal";
import { SignupEncouragementModal } from "./signup-encouragement-modal";
import { ExpiredListeningUpgradeModal } from "./expired-listening-upgrade-modal";

const ModalController = () => {
	const { openedModalId, handleModalOpen, resetSignupTimer } = useApp();

	const closeModal = () => {
		handleModalOpen(openedModalId, false);
	};

	const closeAndResetSignupTimer = () => {
		handleModalOpen(openedModalId, false);
		resetSignupTimer();
	};

	return (
		<>
			<UpgradeToPremiumModal
				isOpen={openedModalId === "UPGRADE_MODAL"}
				close={closeModal}
			/>
			<ExpiredListeningUpgradeModal
				isOpen={openedModalId === "EXPIRED_LISTENING_MODAL"}
				close={closeModal}
			/>
			<AccountRequiredModal
				isOpen={openedModalId === "ACCOUNT_REQUIRED_MODAL"}
				close={closeModal}
			/>
			<SignupEncouragementModal
				isOpen={openedModalId === "SIGNUP_MODAL"}
				close={closeAndResetSignupTimer}
			/>
		</>
	);
};

export default ModalController;
